export const PAGINATION = {
  DEFAULT_FIRST_PAGE: 1,
  DEFAULT_PER_PAGE: 20,
};

export const QUERY_CACHE = {
  DEFAULT: {
    STALE_TIME: 5 * 60 * 1000,
    GC_TIME: 10 * 60 * 1000,
  },
  SEARCH: {
    STALE_TIME: 30 * 1000,
    GC_TIME: 2 * 60 * 1000,
  },
};
